import SearchIcon from "@assets/svg/SearchIcon";
import CallIcon from "@assets/svg/newCall";
import Text from "@components/CustomText";
import EmptySearchList from "@components/SearchHeader/EmptySearchList";
import { deliveryBtnTxt, cxrtoBtnTxt } from "@constants/orderDetails";
import { meta } from "@constants/cplp";
import { colors } from "@constants/theme";
import { useFocusEffect, useIsFocused } from "@react-navigation/native";
import HeaderWithSearch from "@screens/MyDeliveries/HeaderWithSearch";
import MarkDeliveryOrReturnBtn from "@screens/MyDeliveries/components/MarkDeliveryOrReturnBtn";
import {
  getDeliveryOrderItems,
  markMyDeliveyModalAction,
  markCxOrderDelivered,
} from "@services/api";
import handleCallButtonPress from "@utils/handleCallButtonPress";
import debounce from "lodash/debounce";
import React, { useCallback, useMemo, useState, useRef } from "react";
import {
  ActivityIndicator,
  Modal,
  SectionList,
  StyleSheet,
  TouchableOpacity,
  View,
} from "react-native";
import { actions } from "@reducers/rrdReducer";
import { useDispatch, useSelector } from "react-redux";
import toasts from "@utils/toast";
import analytics from "@services/analytics";
import {
  FULL_ORDER_RETURN_RTO,
  ORDER_TRACKING,
} from "@constants/analyticsEventsCT";
import ToastMessage from "@components/Toast";
import ShipmentCard from "@screens/CustomerOrderItems/components/ShipmentCard";
import CrateItem from "@screens/CustomerOrderItems/components/CrateCard";
import useLocationHook from "@components/common/LocationHook";
import MarkingConfirmationModal from "@screens/MyDeliveries/MarkingConfirmationModal";
import InfoLines from "../components/InfoModal/InfoLines";
import EmptyBox from "@assets/svg/EmptyBox";

function getCrateOrShipmentItem(type) {
  return type === "CRATE" || type === "PACKED_ORDERS"
    ? CrateItem
    : ShipmentCard;
}

interface PreDeliveryItemListProps {
  navigation: any;
  route: any;
}

const PreDeliveryItemList: React.FC<PreDeliveryItemListProps> = ({
  navigation,
  route,
}) => {
  const { is_delivery: fromDeliverToCxBtn, afterOtpRedirectScreenName = "" } =
    route?.params;
  const order_id = route?.params?.orders_list[0];

  const { user = {} } = useSelector((state) => state.auth);

  const isFocused = useIsFocused();
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [ordersItem, setOrdersItem] = useState([]);
  const [fullOrdersItem, setFullOrdersItem] = useState([]);
  const [meteData, setMetaData] = useState({});
  const [searchEnable, setSearchEnable] = useState(false);
  const [infoItemState, setInfoItemState] = useState(null);
  const [buttonPress, setButtonPress] = useState(false);
  const [isOfdCp, setIsOfdCp] = useState(false);
  const [allowDeliveryOrRTO, setAllowDeliveryOrRTO] = useState(false);
  const [imagesMandatoryForSamasya, setImagesMandatoryForSamasya] = useState(
    {},
  );
  const [disableOtpBtn, setDisableOtpBtn] = useState(false);
  const [paymentDetails, setPaymentDetails] = useState({});
  const [markingModalInfo, setMarkingModalInfo] = useState({});
  const [warning, setWarning] = useState({
    show_warning: false,
    title: "",
    message: "",
    is_highly_discounted_cart: false,
  });
  const [markingModal, setMarkingModal] = useState(false);
  const [markingConfig, setMarkingConfig] = useState([]);
  const searchRef = useRef("");
  const isProcessingRef = useRef(false);
  const getCurrentLocation = useLocationHook();
  const dispatch = useDispatch();
  useFocusEffect(
    useCallback(() => {
      if (isFocused) {
        fetchData();
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isFocused]),
  );

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const { data } = await getDeliveryOrderItems({
        order_ids: route?.params?.orders_list,
        spoke_name: route?.params?.spokeName || "",
        user_id: route?.params?.user_id,
        date: route?.params?.date || "",
        type: route?.params?.type || "",
        source: "PRE_DELIVERY",
      });
      if (searchEnable && searchRef.current)
        onSearchInputChange(searchRef.current ? searchRef.current : "");
      else setOrdersItem(data?.data);
      setMetaData(data?.meta);
      setFullOrdersItem(data?.data);
      setInfoItemState(data?.item_info_state);
      setWarning(data?.marking_warning || null);
      setMarkingConfig(data?.marking_config || []);
      setIsOfdCp(data?.is_ofd_cp);
      setAllowDeliveryOrRTO(data?.is_issue_item_with_images);
      setImagesMandatoryForSamasya(data?.images_mandatory_for_samasya);
      setPaymentDetails({
        payable_amount: data?.payable_amount,
        payable_amount_text: data?.payable_amount_text,
        payment_mode: data?.payment_mode,
      });
      setMarkingModalInfo({
        delivery_with_otp: data?.delivery_with_otp,
        title: data?.confirm_delivery_modal_title,
        text: data?.confirm_delivery_modal_text,
      });
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
      setIsRefreshing(false);
    }
  };

  const onRefresh = () => {
    setIsRefreshing(true);
    fetchData();
  };

  const sortUpdates = useMemo(() => {
    return ordersItem.map((v) => {
      return {
        ...v,
        data: v.items,
      };
    });
  }, [ordersItem]);

  const handleNavigation = async () => {
    // add checks for single quantity items if (images are required or not)
    if (!allowDeliveryOrRTO) {
      toasts.showShortToast("कृप्या फोटो डालें!");
      return;
    }
    if (fromDeliverToCxBtn) {
      setDisableOtpBtn(true);
      if (isProcessingRef.current) return;
      isProcessingRef.current = true;
      try {
        const coords = await getCurrentLocation(2);
        const response = await markCxOrderDelivered({
          order_id,
          lat: coords.latitude,
          lng: coords.longitude,
        });
        setDisableOtpBtn(false);
        if (response?.data?.error === "OTP_VERIFICATION_FAILED") {
          return navigation.navigate("OTPVerification", {
            action: "confirmDelivery",
            id: order_id,
            otpLength: response?.data?.otpLength || 4,
            otpText: response?.data?.otpText || "",
            afterOtpRedirectScreenName,
            payable_amount: paymentDetails.payable_amount,
            phone_numbers: response.data.phone_numbers || [],
            cx_id: route?.params?.user_id || "",
          });
        }
        if (response.status === 200) {
          ToastMessage("success", response?.data?.toastMessage);
        }
        dispatch(actions.fetchRRDInfo());
        analytics.trackEvent(ORDER_TRACKING.DELIVERY_MARKED_BY_CL, {
          order_id,
          id: route?.params?.user_id,
          city: user.city || "",
        });
        return navigation.pop();
      } catch (e) {
        console.log(e);
        setDisableOtpBtn(false);
      } finally {
        isProcessingRef.current = false;
      }
      return;
    }
    analytics.trackEvent(FULL_ORDER_RETURN_RTO.MARKING_CTA_CLICKED, {
      order_id,
      card_type: "Delivery",
      marking_type: "Return_RTO",
    });
    return navigation.navigate("ReturnCompleteOrder", {
      order_id,
      goBackScreenName: "PreDeliveryItemList",
      ...(route?.params ? route.params : {}),
    });
  };

  const renderItem = useCallback(
    ({ item, section }) => {
      const CrateOrShipmentItem = getCrateOrShipmentItem(section?.type);
      return (
        <CrateOrShipmentItem
          info={item}
          markingConfig={markingConfig}
          fetchData={fetchData}
          imagesMandatoryForSamasya={imagesMandatoryForSamasya}
          source="PRE_DELIVERY"
          isOfdCp={isOfdCp}
          isHighlyDiscountedItem={warning?.is_highly_discounted_cart}
          type={section?.type}
        />
      );
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [imagesMandatoryForSamasya],
  );

  const renderSection = ({ section: { type, data } }) => {
    const sectionTitle =
      type === "CRATE"
        ? meta.crate_item_label
        : type === "PACKED_ORDERS"
          ? meta.packed_orders
          : meta.shipment_label;
    return data.length ? (
      <View style={styles.sectionContainer}>
        <Text variant="body_text_2" style={styles.sectionTitle}>
          {sectionTitle}
        </Text>
      </View>
    ) : null;
  };

  const keyExtractor = (item, index) => `${item.id}_${index}`;

  function RightComponent() {
    return (
      <View style={{ flexDirection: "row" }}>
        <View>
          <TouchableOpacity
            testID="user_phone"
            onPress={() => onPressCall(route?.params?.user_phone)}
          >
            <CallIcon strokeColor="#2195F2" />
          </TouchableOpacity>
        </View>
        <View style={{ marginLeft: 24 }}>
          <TouchableOpacity
            testID="search_enable"
            onPress={() => setSearchEnable(true)}
          >
            <SearchIcon height={20} width={20} />
          </TouchableOpacity>
        </View>
      </View>
    );
  }

  const onPressCall = (phone) => {
    handleCallButtonPress(phone, "CX_NUMBER_CLICKED", {
      type: "call",
      user_id: route?.params?.user_id,
      user_name: route?.params?.user_name,
      orders: route?.params?.orders_list,
    });
  };

  const onPressCrossIcon = () => {
    onSearchInputChange("");
    searchRef.current = "";
  };

  const onSearchInputChange = debounce((text) => {
    const filteredData = fullOrdersItem.map((data) => {
      return {
        ...data,
        items: data?.items?.filter((v) =>
          containText(text, v?.product_name_en),
        ),
      };
    });
    setOrdersItem(filteredData);
    searchRef.current = text;
  }, 500);

  const containText = (text, item) => {
    const lowerCasedText = text?.trim().toLowerCase();
    return item?.toLowerCase().includes(lowerCasedText);
  };

  const getListHeaderComponent = () => {
    return (
      <InfoLines
        info={meteData?.InfoModal}
        state={infoItemState}
        onPress={onPressCut}
      />
    );
  };

  const onPressCut = async () => {
    if (buttonPress) {
      return;
    }
    setButtonPress(true);
    await markMyDeliveyModalAction("item_info_IN_SCREEN");
    await fetchData();
    setButtonPress(false);
  };

  const footerComponent = () => <View style={{ height: 240 }} />;

  const checkItemDatailsEmpty = () => {
    return !sortUpdates.find((v) => v?.data?.length > 0);
  };

  const handlemarkingDelivery = () => {
    if (!fromDeliverToCxBtn) {
      handleNavigation();
    } else {
      if (!markingModalInfo?.delivery_with_otp) {
        setMarkingModal(true);
      } else {
        handleNavigation();
      }
    }
  };
  const HeaderStrip = () => (
    <View style={styles.headerStrip}>
      <EmptyBox />
      <Text
        variant="title_16"
        style={{ color: colors.mediumBlacklightBlack, marginLeft: 8 }}
      >
        {meta?.should_deliver_tag}
      </Text>
    </View>
  );

  return (
    <View style={styles.container}>
      <HeaderWithSearch
        headertitle={`${route?.params?.user_name} जी का ऑर्डर`}
        headerColor="#fff"
        hideShadow={false}
        isSearchEnabled={searchEnable}
        navigation={navigation}
        route={route}
        rightComponent={<RightComponent />}
        subHeadingComponent={<View style={{ marginBottom: 10 }} />}
        onPressCrossIcon={onPressCrossIcon}
        onSearchInputChange={onSearchInputChange}
        searchPlaceholder="आइटम सर्च करें…"
        bottomComponent={meta?.should_deliver_tag ? <HeaderStrip /> : null}
      />
      {checkItemDatailsEmpty() ? (
        <EmptySearchList />
      ) : (
        <View style={{ flex: 1 }}>
          <SectionList
            renderSectionHeader={renderSection}
            ListHeaderComponent={getListHeaderComponent}
            keyExtractor={keyExtractor}
            contentContainerStyle={{ paddingBottom: 60 }}
            sections={sortUpdates}
            renderItem={renderItem}
            keyboardShouldPersistTaps="handled"
            ListFooterComponent={footerComponent}
            onRefresh={onRefresh}
            refreshing={isRefreshing}
          />
          <View style={styles.bottomButtonContainer}>
            {fromDeliverToCxBtn ? (
              <View style={styles.warningContainer}>
                <Text
                  variant="title_18_regular"
                  style={{ color: "#00AB59", fontSize: 16 }}
                >
                  {paymentDetails?.payable_amount_text || ""}
                  <Text
                    variant="title_18"
                    style={{ color: "#00AB59", fontSize: 20 }}
                  >
                    {paymentDetails?.payable_amount
                      ? ` ₹${paymentDetails.payable_amount}`
                      : ""}
                  </Text>
                </Text>
                {warning && warning?.show_warning ? (
                  <Text
                    variant="body_text_2"
                    style={{ color: "#E40046", marginTop: 2 }}
                  >
                    {warning?.title || ""}
                    <Text variant="body_text_2" style={{ color: "black" }}>
                      {` ${warning?.message || ""}`}
                    </Text>
                  </Text>
                ) : null}
              </View>
            ) : null}
            <MarkDeliveryOrReturnBtn
              fromDeliverToCxBtn={fromDeliverToCxBtn}
              handleNavigation={handlemarkingDelivery}
              btn_txt={fromDeliverToCxBtn ? deliveryBtnTxt : cxrtoBtnTxt}
              disabled={disableOtpBtn || isProcessingRef.current}
            />
          </View>
        </View>
      )}
      <MarkingConfirmationModal
        visible={markingModal}
        onPress={handleNavigation}
        onPressCancel={() => setMarkingModal(false)}
        title={markingModalInfo?.title}
        text={markingModalInfo?.text}
        disableBtn={isProcessingRef.current}
      />
      <Modal visible={isLoading} transparent={true}>
        <View style={styles.loadingView}>
          <ActivityIndicator size="large" color={colors.primary} />
        </View>
      </Modal>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  loadingView: {
    justifyContent: "center",
    alignItems: "center",
    flex: 1,
    backgroundColor: colors.black02,
  },
  sectionContainer: {
    padding: 12,
    backgroundColor: "white",
    paddingLeft: 16,
    marginTop: 12,
  },
  sectionTitle: { color: "#000" },
  bottomButtonContainer: {
    position: "absolute",
    bottom: 0,
    backgroundColor: "white",
    paddingBottom: 10,
    width: "100%",
    padding: 12,
  },
  warningContainer: {
    width: "100%",
    backgroundColor: "#F5FFFA",
    paddingVertical: 8,
    paddingHorizontal: 12,
    borderWidth: 1,
    borderColor: "#00AB59",
    marginBottom: 10,
    borderRadius: 8,
  },
  headerStrip: {
    flexDirection: "row",
    backgroundColor: "rgba(255, 249, 248, 1)",
    paddingVertical: 6,
    borderBottomLeftRadius: 12,
    borderBottomRightRadius: 12,
    elevation: 1,
    alignContent: "center",
    alignItems: "center",
    justifyContent: "center",
  },
});

export default PreDeliveryItemList;
